import { ENUM } from "~/plugins/constants/enum";
import { displayDate, getChatbotStatus } from "~/plugins/functions/display";

// For DTO Knowledge
export interface IModelGETKnowledgeRequest {
  orderBy?: string;
  orderType?: string;
  count?: boolean;
  page?: number;
  limit?: number;
  query?: string;
}

export interface IModelGETKnowledgeResponse {
  id: string;
  name: string;
  description: any;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
  softDeleted: boolean;
  status: string;
}

export class ModelGETKnowledge {
  id: string;
  name: string;
  description: any;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
  softDeleted: boolean;
  status: string;

  displayCreatedAt: string;
  displayUpdatedAt: string;
  displayStatus: string;

  constructor(props = {} as IModelGETKnowledgeResponse) {
    props = props ?? {} as IModelGETKnowledgeResponse;
    this.id = props.id || '';
    this.name = props.name || '';
    this.description = props.description || null;
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt || '';
    this.updatedBy = props.updatedBy || null;
    this.softDeleted = props.softDeleted || false;
    this.status = props.status || '';

    this.displayCreatedAt = displayDate(this.createdAt, {
      isTime: true
    });
    this.displayUpdatedAt = displayDate(this.updatedAt, {
      isTime: true
    });
    this.displayStatus = getChatbotStatus(this.status)
  }
}

